import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useStore } from 'vuex'
import { onBeforeMount, onBeforeUnmount, onMounted } from '@vue/runtime-core'
import { ref } from 'vue';

import { setSdkRegionCode } from '@/api/newdatarequest'

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore()
let idleTimer: any = null

const freq = ref(Number(localStorage.getItem("pinlv")))

// 用户交互事件：任何交互都会重置闲置计时器，避免操作到一半被强制刷新
const activityEvents = ['mousemove', 'mousedown', 'click', 'keydown', 'input', 'scroll', 'touchstart']

const resetIdleTimer = () => {
	if (!freq.value) return
	if (idleTimer) clearTimeout(idleTimer)
	idleTimer = setTimeout(() => {
		location.reload()
	}, freq.value)
}

const clearRefreshListeners = () => {
	if (idleTimer) clearTimeout(idleTimer)
	activityEvents.forEach((evt) => window.removeEventListener(evt, resetIdleTimer))
}

const saveState = () => {
	localStorage.setItem('state', JSON.stringify(store.state))
}

onMounted(() => {
	// console.log('lifcycle',window.lifecycle)
	// lifecycle.es5.js 若加载失败（例如非首页路由下路径解析错误），不能影响整个应用挂载
	const lifecycle = (window as any).lifecycle
	if (lifecycle && typeof lifecycle.addEventListener === 'function') {
		lifecycle.addEventListener('statechange', function (event: any) {
			saveState()
			// console.log('状态变化：' + event.oldState + ' → ' + event.newState);
		});
	}
	// window.addEventListener('beforeunload', saveState)
	if (freq.value) {
		// 仅在用户闲置达到设定频率时刷新，操作中不会被打断
		resetIdleTimer()
		activityEvents.forEach((evt) => window.addEventListener(evt, resetIdleTimer, { passive: true }))
	}
})

onBeforeUnmount(() => {
	clearRefreshListeners()
})

 onBeforeMount(() => {
	if (localStorage.length !== 0) {
		if (localStorage.state) {
			const savedState = JSON.parse(localStorage.state)
			store.commit('reloads', savedState);
			// 恢复 X-Region 请求头
			const selectedRegion = savedState.selectedRegion
			if (selectedRegion?.code) {
				setSdkRegionCode(selectedRegion.code)
			}
		}
	}
})



return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})